 <!-- ======= Sidebar ======= -->
<aside id="sidebar" class="sidebar" *ngIf="parentData.length > 0">
  <div class="side-icon">
    <div class="tsb-btn">
      <a class="toggle-sidebar-btn" (click)="toggleSidebar()">
        <img src="../../../../assets/images/open_menu.svg">
      </a>
    </div>
    <ul class="nav " id="myTab" role="tablist">
      <li role="presentation" data-bs-toggle="tooltip"
          data-bs-placement="top" title="{{menuItem.title}}"
          *ngFor="let menuItem of parentData; let _index = index;">
        <a (click)="goToPage(menuItem, _index)" id="nav-link-{{menuItem.id}}"
           class="nav-link submenu_a_{{menuItem.code ? menuItem.code.replace(' ', '').toLowerCase() :''}}">
          <img [src]="menuItem.fileUrl">
          <span> {{menuItem.title}}</span>
        </a>
      </li>
    </ul>
  </div>
</aside>
<!-- End Sidebar-->
